<template>
  <div class="container">
    <GenericContentComponentUsage :title-key="titleKey">
      <slot />
    </GenericContentComponentUsage>

    <!--    <TextBody i18n-key="whatCanIUseFor.whatCanIUseFor" color="#FFD853" tag="div" />-->
    <!--    <div class="use-items-container">-->
    <!--      <BbBtn v-for="(item, index) in useItems" :key="index" class="use-item" size="small" type="secondary">-->
    <!--        <TextBody :i18n-key="`whatCanIUseFor.${item}`" tag="div" color="#fff" :body-type="3" />-->
    <!--      </BbBtn>-->
    <!--    </div>-->
  </div>
</template>

<script>
import GenericContentComponentUsage from '~/components/conversation/sidepanelGeneralComponents/GenericContentComponentUsage.vue';

export default {
  components: { GenericContentComponentUsage },
  props: {
    titleKey: {
      type: String,
      default: '',
    },
  },
  setup() {
    const useItems = ['createAnEmail', 'searchAskQuestions', 'extractKeyInfo', 'convertOtherFormats', 'summarize'];

    return {
      useItems,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: $bb-neutral-1;
  padding: $bb-spacing-4;
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-3;

  .use-items-container {
    display: flex;
    align-items: center;
    gap: $bb-spacing-1;
    flex-wrap: wrap;
    flex-direction: row;

    .use-item {
      background-color: $bb-neutral-2 !important;
      border: unset;
      display: block;
      height: 32px !important;
    }
  }
}
</style>
